// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"0670771c","206":"937bd453","228":"6f0e78a0","566":"04ebfbf8"}[chunkId] + ".chunk.css";
};